'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BoxCTA } from '@lichtblick/photon/atoms/box-cta/box-cta';
import { MagnifyingGlassXs } from '@lichtblick/photon/icons/objects/magnifying-glass-xs';
import { Label } from '@lichtblick/photon/molecules/label/label';
import { useTracker } from '@lichtblick/tracker';
import classNames from 'classnames';
import styles from './soft-funnel-entry.module.scss';
import { Textfield } from './Textfield';
export const SoftFunnelEntryCard = ({ theme, title })=>{
    const { trackCustomEvent } = useTracker();
    return /*#__PURE__*/ _jsx("div", {
        className: classNames(styles['stage-card'], styles[`theme-${theme}`]),
        children: /*#__PURE__*/ _jsxs("form", {
            action: "/zuhause/solar/",
            className: styles['funnel-form'],
            onSubmit: ()=>trackCustomEvent({
                    eventName: 'eaas_soft_funnel_cta'
                }),
            method: "GET",
            children: [
                /*#__PURE__*/ _jsx(Label, {
                    bold: true,
                    htmlFor: "zipCode",
                    renderAs: "label",
                    children: title || 'Wo soll Deine SolarAnlage installiert werden?'
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: styles.controls,
                    children: [
                        /*#__PURE__*/ _jsx(Textfield, {
                            className: styles['text-field'],
                            leftSlot: /*#__PURE__*/ _jsx(MagnifyingGlassXs, {
                                className: styles['styled-search-icon']
                            }),
                            name: "plz",
                            pattern: "\\d{5}",
                            placeholder: "Postleitzahl eingeben",
                            required: true
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: styles['button-wrapper'],
                            children: /*#__PURE__*/ _jsx(BoxCTA, {
                                as: "button",
                                variant: "primary",
                                wide: true,
                                children: "SolarAnlage berechnen"
                            })
                        })
                    ]
                })
            ]
        })
    });
};
export const SoftFunnelEntry = ({ paddingBottomDesktop, paddingBottomMobile, paddingTopDesktop, paddingTopMobile, theme, ...props })=>{
    return /*#__PURE__*/ _jsx("section", {
        className: classNames(styles.root, styles[`theme-${theme}`], styles['root-pbd-xl'], styles[`root-ptm-${paddingTopMobile || 'm'}`], styles[`root-pbm-${paddingBottomMobile || 'm'}`], styles[`root-ptd-${paddingTopDesktop || 'xl'}`], styles[`root-pbd-${paddingBottomDesktop || 'xl'}`], styles[`root-pbd-${paddingBottomDesktop || 'xl'}`]),
        children: /*#__PURE__*/ _jsx(SoftFunnelEntryCard, {
            ...props,
            theme: theme
        })
    });
};

//# sourceMappingURL=SoftFunnelEntry.js.map